<template>
  <div class="comContent">
    <div class="title">
      <div>
        <span class="font">资质证件</span>
        <span class="font-tip"
          >当前支持对[营业执照]、[法人身份证]的OCR信息识别</span
        >
      </div>
    </div>
    <div class="btns">
      <el-button size="small" type="primary" @click="addItem"> 新增 </el-button>
    </div>
    <div class="center">
      <MyTable
        :table-data="tableData"
        :showpage="false"
        :index="false"
        :operation="true"
        :table-option.sync="tableOption"
      >
        <template slot="menu" slot-scope="scope">
          <el-link
            :underline="false"
            type="primary"
            @click="editItem(scope.row)"
            >编辑</el-link
          >
          <el-popconfirm title="确定删除吗？" @confirm="deleteItem(scope.row)">
            <el-link
              :underline="false"
              style="margin-left: 16px"
              type="primary"
              slot="reference"
              >删除</el-link
            >
          </el-popconfirm>
        </template>
      </MyTable>
    </div>
    <ConfirmDialog
      :dialogShow="documentsDialogShow"
      :title="title"
      :showFooter="true"
      :width="800"
      @updateDialogShow="updateDialogShow"
      @confirm="confirm"
    >
      <el-form
        label-width="80px"
        :model="form"
        ref="form"
        class="form"
        size="mini"
        :rules="formRules"
        @submit.native.prevent
      >
        <el-form-item label="证件名称" prop="cardName">
          <el-input v-model="form.cardName" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sortNum">
          <el-input type="number" v-model="form.sortNum"></el-input>
        </el-form-item>
      </el-form>
    </ConfirmDialog>
  </div>
</template>
<script>
import MyTable from "@/components/myTable";
import ConfirmDialog from "@/components/ConfirmDialog";
import {
  saveCompcertificates,
  updateCompcertificates,
  getCompcertificatesAllList,
  deleteCompcertificates,
} from "@/api/qualification/qualification";

export default {
  name: "QualificationDocumentsManager",
  components: { MyTable, ConfirmDialog },
  computed: {
    title() {
      if (this.type == "add") {
        return "新增资质证件";
      } else {
        return "编辑资质证件";
      }
    },
  },
  data() {
    return {
      type: "add", //add,edit
      documentsDialogShow: false,
      form: {
        cardName: "",
        sortNum: "",
      },
      formRules: {
        cardName: [
          { required: true, message: "请输入证件名称", trigger: "change" },
        ],
        sortNum: [
          { required: true, message: "请输入排序数字", trigger: "change" },
        ],
      },
      tableOption: [
        { label: "证件名称", prop: "cardName" },
        { label: "排序", prop: "sortNum" },
      ],
      tableData: [],
    };
  },
  methods: {
    queryTable() {
      getCompcertificatesAllList().then((res) => {
        this.tableData = res.data.map((item) => {
          item.cardName = item.name;
          item.sortNum = item.sort;
          return item;
        });
      });
    },
    updateDialogShow(vis) {
      this.documentsDialogShow = vis;
    },
    resetForm() {
      this.form = {
        id: "",
        cardName: "",
        sortNum: "",
      };
    },
    initForm(row) {
      this.form = Object.assign(this.form, row);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            saveCompcertificates({
              name: this.form.cardName,
              sort: this.form.sortNum,
            }).then((res) => {
              this.$message.success("新增成功");
              this.queryTable();
            });
          } else {
            updateCompcertificates({
              id: this.form.id,
              name: this.form.cardName,
              sort: this.form.sortNum,
            }).then((res) => {
              this.$message.success("编辑成功");
              this.queryTable();
            });
          }
          this.updateDialogShow(false);
        }
      });
    },
    addItem() {
      this.type = "add";
      this.resetForm();
      this.updateDialogShow(true);
    },
    editItem(row) {
      this.type = "edit";
      this.initForm(row);
      this.updateDialogShow(true);
    },
    deleteItem(row) {
      deleteCompcertificates({ id: row.id }).then((res) => {
        this.$message.success("删除成功");
        this.queryTable();
      });
    },
  },
  mounted() {
    this.queryTable();
  },
};
</script>
<style lang='scss' scoped>
.comContent {
  padding: 0px;
  .title {
    height: 56px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f5f5ff;
  }
  .center {
    margin: 0 24px;
    margin-top: 16px;
    height: calc(100% - 131px);
    width: auto;
  }
  .btns {
    margin: 0 24px;
    margin-top: 16px;
  }
  .font-tip {
    padding-left: 10px;
    font-size: 12px;
    color: rgb(238, 214, 82);
  }
}
</style>